<template>
    <div class="box">
        <div class="header">
            <div class="filter">
                <ul class="filter-box">
                    <li>
                        <span>{{ $t('hardEncoder.List.filter.deviceCodeLike') }}</span>
                        <Input
                                clearable
                                v-model="filter.deviceCodeLike"
                                size="small"
                                class="selector"
                                :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <li>
                        <span>{{ $t('hardEncoder.List.filter.deviceNameLike') }}</span>
                        <Input
                                clearable
                                v-model="filter.deviceNameLike"
                                size="small"
                                class="selector"
                                :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <li v-if="dep">
                        <span>{{ $t('hardEncoder.List.filter.userCode') }}</span>
                        <Input
                                clearable
                                v-model="filter.userCode"
                                size="small"
                                class="selector"
                                :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                </ul>
                <Button 
                    class="refresh-button" 
                    type="primary" 
                    size="small"
                    @click="refresh">
                    {{ $t('Button.refresh') }}
                </Button>
            </div>
        </div>
        <div ref="list" class="content">
            <table class="list">
                <thead>
                <td>{{ $t('hardEncoder.List.list.deviceCode') }}</td>
                <td >{{ $t('hardEncoder.List.list.deviceName') }}</td>
                <td>{{ $t('hardEncoder.List.list.encoderStreamType') }}</td>
                <td>{{ $t('hardEncoder.List.list.roomId') }}	</td>
                <td>{{ $t('hardEncoder.List.list.roomTitle') }}</td>
                <td>{{ $t('hardEncoder.List.list.runStatus') }}</td>
                <td>{{ $t('hardEncoder.List.list.useStatus') }}</td>
                <td v-if="dep">{{ $t('hardEncoder.List.list.userName') }}</td>
                <td>{{ $t('hardEncoder.List.list.operation') }}</td>

                </thead>

                <tr v-for="i in list" :key="i.id">
                    <td>{{i.deviceCode}}</td>
                    <td>{{ i.deviceName }}</td>

                    <td v-if="i.encoderStreamType == 0">{{ $t('hardEncoder.encoderStreamType.old') }}</td>
                    <td v-else-if="i.encoderStreamType == 1">{{ $t('hardEncoder.encoderStreamType.newM') }}</td>
                    <td v-else>{{ $t('hardEncoder.encoderStreamType.newC') }}</td>

                    <td>{{ i.roomId }}</td>
                    <td>{{ i.roomTitle }}</td>

                    <td v-if="i.runStatus == 0">{{ $t('hardEncoder.runStatus.disconnect') }}</td>
                    <td v-else-if="i.runStatus == 1">{{ $t('hardEncoder.runStatus.standBy') }}</td>
                    <td v-else-if="i.runStatus == 2">{{ $t('hardEncoder.runStatus.pushStart') }}</td>
                    <td v-else-if="i.runStatus == 3">{{ $t('hardEncoder.runStatus.pushing') }}</td>
                    <td v-else-if="i.runStatus == 4">{{ $t('hardEncoder.runStatus.error') }}</td>
                    <td v-else>{{ $t('hardEncoder.runStatus.pushStop') }}</td>

                    <td v-if="i.useStatus == 0">{{ $t('hardEncoder.useStatus.normal') }}</td>
                    <td v-else>{{ $t('hardEncoder.useStatus.forbidden') }}</td>

                    <td v-if="dep">{{ i.userName }}</td>
                    <td>
                        <Button
                                v-if="hasPermission('hardEncoderEdit')"
                                class="block_btn"
                                type="dashed"
                                icon="md-settings"
                                @click="$router.push('detail/'+i.id)"
                        >{{ $t('Button.edit') }}</Button>
                        <div v-if="i.roomId > 0">
                            <Button v-show="i.runStatus == 1"
                                    class="block_btn"
                                    type="dashed"
                                    icon="md-settings"
                                    @click="startPush(i.id)"
                            >{{ $t('hardEncoder.List.button.startPush') }}</Button>
                            <Button v-show="i.runStatus == 3"
                                    class="block_btn"
                                    type="dashed"
                                    icon="md-settings"
                                    @click="stopPush(i.id)"
                            >{{ $t('hardEncoder.List.button.stopPush') }}</Button>
                            <Button v-show="i.runStatus == 4"
                                    class="block_btn"
                                    type="dashed"
                                    icon="md-settings"
                                    @click="startPush(i.id)"
                            >{{ $t('hardEncoder.List.button.startPush') }}</Button>
                            <Button v-show="i.runStatus == 5"
                                    class="block_btn"
                                    type="dashed"
                                    icon="md-settings"
                                    @click="startPush(i.id)"
                            >{{ $t('hardEncoder.List.button.startPush') }}</Button>
                            <Button v-show="i.runStatus != 0"
                                    v-if="hasPermission('hardEncoderReset')"
                                    class="block_btn"
                                    type="dashed"
                                    icon="md-refresh"
                                    @click="restart(i.id,3,i.userId)"
                            >{{ $t('hardEncoder.List.button.reset') }}</Button>
                            <Button v-show="i.runStatus != 0"
                                    v-if="hasPermission('hardEncoderRestart')"
                                    class="block_btn"
                                    type="dashed"
                                    icon="md-power"
                                    @click="restart(i.id,4,i.userId)"
                            >{{ $t('hardEncoder.List.button.restart') }}</Button>
                        </div>

                    </td>
                </tr>
            </table>

            <Spin v-show="loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                    class="pager"
                    :total="pagination.total"
                    :current="pagination.page"
                    :page-size="pagination.pageSize"
                    @on-change="v=>pagination.page=v"
                    @on-page-size-change="v=>pagination.pageSize=v"
                    show-elevator
                    show-sizer
                    transfer
            />
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import api from "@/api/Api";
    import extend from "extend";
    export default {
        data(){
            return {
                loading: true,
                dialog: false,
                dialog_loading: false,
                list: [],
                hardEncoderSettings: {
                    id: 0,
                    runStatus:0,
                    useStatus:0,
                    terminalUserId:0
                }
            }
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.hardEncoder.all.filter;
                },
                set(v) {
                    this.$store.commit("views/hardEncoder.all.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.hardEncoder.all.pagination;
                },
                set(v) {
                    this.$store.commit("views/hardEncoder.all.pagination", v);
                }
            },
            dep(){
                return this.filter.selectType == 2
            },
            ...mapState({
                userId: state => state.user.id
            })
        },
        watch: {
            'filter.depId'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.deviceCodeLike'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.deviceNameLike'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.userCode'() {
                this.pagination.page = 1;
                this.refresh();
            },
            "pagination.page": "refresh",
            "pagination.pageSize": "refresh"
        },
        methods: {
            async startPush(id){
                if (!confirm(this.$t('hardEncoder.List.message.startPush.confirm'))) return;
                try {
                    let ret = await api.call("hardEncoder/startPush", {
                        id: id
                    });
                    this.$Notice.success({ title: this.$t('hardEncoder.List.message.startPush.success') });
                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('hardEncoder.List.message.startPush.error') });
                }
            },
            async stopPush(id){
                if (!confirm(this.$t('hardEncoder.List.message.stopPush.confirm'))) return;
                try {
                    let ret = await api.call("hardEncoder/stopPush", {
                        id: id
                    });
                    this.$Notice.success({ title: this.$t('hardEncoder.List.message.stopPush.success') });
                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('hardEncoder.List.message.stopPush.error') });
                }
            },
            async restart(id, action, userId){
                let tips = this.$t('hardEncoder.List.message.re.set');
                if(action == 4){
                    tips = this.$t('hardEncoder.List.message.re.start');
                }
                if (!confirm(tips)) return;
                try {
                    let ret = await api.call("hardEncoder/restart", {
                        id: id,
                        action: action,
                        userId: userId
                    });
                    this.$Notice.success({ title: this.$t('hardEncoder.List.message.re.success') });
                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('hardEncoder.List.message.re.error') });
                }
            },
            async refresh() {
                this.loading = true;

                try {
                    let ret = await api.call(
                        "hardEncoder/list",
                        extend(true, {}, this.pagination, this.filter)
                    );

                    this.list = ret.list;
                    this.pagination.total = ret.total;
                } catch (e) {
                    console.log(e)
                }

                this.loading = false;
            }
        },
        mounted() {
            this.refresh();
        }
    }
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {
    }
    .header {
        & > * {
            margin-bottom: 10px;
            border-radius: 5px;
        }
        .toolbar {
            height: 32px;
            line-height: 32px;

            button {
                margin-right: 22px;
                vertical-align: middle;
            }

            .search {
                width: 200px;
            }
        }
        .filter {
            padding: 10px 20px;
            background: #fff;

            .filter-box {
                list-style: none;
                display: inline-block;
                & > li {
                    display: inline-block;
                }
            }
        }
    }
    .content {
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 0 20px;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
    .list {
        width: 100%;
        border-radius: 5px;
        border-collapse: collapse; /*表格的边框合并，如果相邻，则共用一个边框*/
        border-spacing: 0; /*设置行与单元格边框的间距。当表格边框独立（即border-collapse:separate;）此属性才起作用*/

        td {
            padding: 12px 0;
            border-bottom: 1px solid #e9e9e8;
        }

        .block_btn{
            display: block;
        }
    }
    .pager {
        text-align: center;
        padding: 10px;
    }

    .selector {
        display: inline-block;
        width: auto;
    }
</style>